import { generateTokenAuthHeader } from "../../../commonfunctions/authentication";
import { ProductListAPIResponse } from "../../../interfaces/interfaces";

export interface ProductsFetchResult {
  status: number;
  message: string;
  products: ProductListAPIResponse["products"] | null;
}

const getProducts = async (branch: string, optionalParams = ""): Promise<ProductsFetchResult> => {
  try {
    const baseUrl = `${process.env.REACT_APP_HONEYBEE_ROOT_API}/products`;
    const caller = "firebee";
    const params = `?page=1&per_page=12${optionalParams}`;
    const url = `${baseUrl}/${branch}/${params}&caller=${caller}`;

    const res = await fetch(url, generateTokenAuthHeader());
    const data = await res.json();

    return {
      status: 200,
      message: "ok",
      products: data?.products ?? null,
    };
  } catch (error) {
    return {
      status: 500,
      message: "Failed to load products",
      products: null,
    };
  }
};

export default getProducts;
